import { AbstractModel, DateUtil, isNullOrUndefined } from '@uzurv/core';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';
import { DriverBankTransaction } from './driver-bank-transaction';
import { Payment } from './payment';

@inheritSerialization(AbstractModel)
export class Payout extends AbstractModel {
  @autoserialize
  driverId: number;

  @autoserializeAs(DriverBankTransaction)
  driverBankTransaction: DriverBankTransaction;

  @autoserialize
  amount: number;

  @autoserializeAs(Payment)
  payment: Payment;

  @autoserialize
  processedDate: Date;

  static OnSerialized(payout: Payout, json: any): void {
    super.OnSerialized(payout, json);

    if (!isNullOrUndefined(payout.processedDate)) {
      json.processedDate = DateUtil.serializeDate(payout.processedDate);
    }
  }

  static OnDeserialized(instance: Payout, json: any): void {
    super.OnDeserialized(instance, json);

    if (!isNullOrUndefined(json['processedDate'])) {
      instance.processedDate = DateUtil.deserializeDate(json['processedDate']);
    }
  }
}
